module.exports = __webpack_public_path__ + "static/media/vivot.fa0f6de8.jpeg";